import { RESPONSE_MESSAGE_TYPES } from '../constants';
export const normalizeHttpQuickReplyResponse = (message) => {
    return {
        text: message.text,
        quick_replies: message.buttons.map(button => ({
            content_type: 'text',
            payload: button.payload,
            title: button.title,
        })),
    };
};
export const normalizeHttpImageResponse = (message) => {
    return {
        attachment: {
            payload: {
                alt: '',
                src: message.image,
            },
            type: RESPONSE_MESSAGE_TYPES.IMAGE,
        },
    };
};
export function isHttpQuickReplyResponse(response) {
    return response.buttons !== undefined;
}
export function hasCustomAttribute(response) {
    return ('custom' in response &&
        response.custom !== undefined &&
        (response.custom.type === RESPONSE_MESSAGE_TYPES.CAROUSEL ||
            response.custom.type === RESPONSE_MESSAGE_TYPES.VIDEO ||
            response.custom.type === RESPONSE_MESSAGE_TYPES.ACCORDION ||
            response.custom.type === RESPONSE_MESSAGE_TYPES.FILE_DOWNLOAD ||
            response.custom.type === RESPONSE_MESSAGE_TYPES.RATING));
}
export function isHttpImageResponse(response) {
    return response.image !== undefined;
}
export function isHttpTextResponse(response) {
    return response.text !== undefined;
}
//# sourceMappingURL=HTTPConnection.utils.js.map